import { render } from "./CookiePolicyMessage.vue?vue&type=template&id=40f306c6&scoped=true"
import script from "./CookiePolicyMessage.vue?vue&type=script&lang=js"
export * from "./CookiePolicyMessage.vue?vue&type=script&lang=js"

import "./CookiePolicyMessage.vue?vue&type=style&index=0&id=40f306c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f306c6"]])

export default __exports__